import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ item }) => (
  <div className="project-item">
    <div className="project-img">
      <Link to={item.link}>
        {item.image ? (
          <img src={item.image} alt={item.title} />
        ) : (
          <div className="project-img-placeholder" aria-hidden="true" />
        )}
      </Link>
    </div>
    <div className="project-content">
      <div className="p-icon">
        <Link to={item.link}>
          <i className="fi fi-rr-arrow-small-right" />
        </Link>
      </div>
      <div className="project-inner">
        <span className="category">
          <Link to={item.link}>{item.category}</Link>
        </span>
        <h3 className="title">
          <Link to={item.link}>{item.title}</Link>
        </h3>
      </div>
    </div>
  </div>
);

export default ProjectCard;
